import Vue from 'vue'
import antVue from 'ant-design-vue'
import './styles/common/index.less'
import zh from 'ant-design-vue/lib/locale-provider/zh_CN'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import './router/permission'
import '../../utils/util'

Vue.config.productionTip = false
Vue.use(antVue)

new Vue({
  router,
  store,
  render () {
    return <a-locale-provider locale={zh}>
      <App/>
    </a-locale-provider>
  }
}).$mount('#app')
